import 'bootstrap-select';

$.fn.selectpicker.Constructor.BootstrapVersion = '4';

ko.bindingHandlers.selectPicker = {
    init: async (element, valueAccessor, allBindingsAccessor) => {
        let observable = valueAccessor() || {},
            value = ko.utils.unwrapObservable(observable);

        ko.bindingHandlers.options.init(element, value.options, allBindingsAccessor);

        let defaults = {
            noneSelectedText: ''
        };

        let options = $.extend(defaults, value);

        // Check if selectpicker is inside modal dialog
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            options.mobile = true;
        }

        $(element).selectpicker(options);

        if (value.changed && typeof(value.changed) === 'function') {
            $(element).on("changed.bs.select", value.changed);
        }

        //if ($(element).is('select')) {
        //    if (ko.isObservable(valueAccessor())) {
        //        if ($(element).prop('multiple') && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
        //            // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
        //            ko.bindingHandlers.selectedOptions.init(element, valueAccessor, allBindingsAccessor);
        //        } else {
        //            // regular select and observable so call the default value binding
        //            ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
        //        }
        //    }
        //}


        //let $element = $(element);

        

        //let defaults = {
        //    noneSelectedText: ''
        //};

        //// Check if selectpicker is inside modal dialog
        //if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        //    options.mobile = true;
        //}

        //options = $.extend(defaults, options);

        //$element.selectpicker(options);

        //var doRefresh = () => {
        //    $element.selectpicker('refresh');
        //}, subscriptions = [];

        //var addSubscription = function (bindingKey) {
        //    var targetObs = allBindingsAccessor.get(bindingKey);

        //    if (targetObs && ko.isObservable(targetObs)) {
        //        subscriptions.push(targetObs.subscribe(doRefresh));
        //    }
        //};

        //addSubscription('options');
        //addSubscription('value');           // Single
        //addSubscription('selectedOptions'); // Multiple

        //ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
        //    $element.selectpicker('destroy');

        //    while (subscriptions.length) {
        //        subscriptions.pop().dispose();
        //    }
        //});
    },
    update: function (element, valueAccessor, allBindingsAccessor) {
        let observable = valueAccessor() || {},
            value = ko.utils.unwrapObservable(observable);

        //var $element = $(element);

        //var disabled = ko.unwrap(allBindingsAccessor().selectPickerDisabled) || false;
        //if ($element.attr("disabled") != disabled) {
        //    $element.attr("disabled", disabled);
        //    $element.selectpicker("refresh");
        //}

        if ($(element).is('select')) {
            ko.bindingHandlers.options.update(element, value.options, allBindingsAccessor);

            //var selectPickerOptions = allBindingsAccessor().selectPickerOptions;
            //if (typeof selectPickerOptions !== 'undefined' && selectPickerOptions !== null) {
            //    var options = selectPickerOptions.optionsArray,
            //        optionsText = selectPickerOptions.optionsText,
            //        optionsValue = selectPickerOptions.optionsValue,
            //        optionsCaption = selectPickerOptions.optionsCaption,
            //        isDisabled = selectPickerOptions.disabledCondition || false,
            //        resetOnDisabled = selectPickerOptions.resetOnDisabled || false;
            //    if (ko.utils.unwrapObservable(options).length > 0) {
            //        // call the default Knockout options binding
            //        ko.bindingHandlers.options.update(element, options, allBindingsAccessor);
            //    }
            //    if (isDisabled && resetOnDisabled) {
            //        // the dropdown is disabled and we need to reset it to its first option
            //        $(element).selectpicker('val', $(element).children('option:first').val());
            //    }
            //    $(element).prop('disabled', isDisabled);
            //}
            //if (ko.isObservable(valueAccessor())) {
            //    if ($(element).prop('multiple') && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
            //        // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
            //        ko.bindingHandlers.selectedOptions.update(element, valueAccessor);
            //    } else {
            //        // call the default Knockout value binding
            //        ko.bindingHandlers.value.update(element, valueAccessor);

            //    }
            //}

            $(element).selectpicker('refresh');
        }
    }
}